import { useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Divider from "@amzn/meridian/esm/components/divider";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Tile from "@amzn/meridian/esm/components/tile";
import {
  MISSING_VALUE,
  REGULAR_COLLABORATOR_MIN_MEETINGS,
} from "./whosWho.constants";
import { classifyWhosWhoInsights } from "./whosWho.utils";
import InsightSlot from "./InsightSlot";
import InviteeOverview from "./InviteeOverview";
import ProfilePhoto from "./ProfilePhoto";

const getMetBeforeLabel = (count) => count >= REGULAR_COLLABORATOR_MIN_MEETINGS
  ? "Regular collaborator"
  : count > 0
    ? `Met before ${count} ${count === 1 ? "time" : "times"}`
    : "First time meeting";

const InviteeCard = ({ person, isError, accentColor }) => {
  const [expanded, setExpanded] = useState(false);
  const isExternal = person.external;
  const canExpand = !isError && !isExternal && !person.isYou;
  const metBeforeLabel = getMetBeforeLabel(person.metBeforeCount);
  const { pinnedInsight, expandedInsights } = classifyWhosWhoInsights(person.insights);

  const cardWidths = isError ? ["fill"] : ["fit", "fill"];

  const showErrorDetail = isError && !isExternal && !person.isYou;
  const toggleExpanded = () => setExpanded((value) => !value);

  return (
    <Tile accent={accentColor} accentPosition="start" spacingInset="300">
      <Row
        width="100%"
        widths={cardWidths}
        spacing="350"
        alignmentVertical="top"
      >
        {!isError && (
          <Column spacing="200" alignmentHorizontal="center">
            <ProfilePhoto
              alias={person.alias}
              initials={person.initials}
              hasPhoto={person.hasPhoto}
            />
            {!isExternal && person.alias && (
              <Text type="b100" color="secondary">{person.alias}</Text>
            )}
          </Column>
        )}
        <Column spacing="200" width="fill">
          <InviteeOverview
            person={person}
            isError={isError}
            canExpand={canExpand}
            pinnedInsight={pinnedInsight}
            expanded={expanded}
            onToggle={toggleExpanded}
          />

          {canExpand && expanded && (
            <Column spacing="200">
              <Box spacingInset="300 none">
                <Divider />
              </Box>
              <Text type="b100" color="secondary" tag="ul" listStyle="disc">
                <Text type="b100" color="secondary" tag="li">
                  {metBeforeLabel}
                </Text>
                {expandedInsights.map((insight, index) => (
                  <Text
                    key={`${insight.kind}-${index}`}
                    type="b100"
                    color="secondary"
                    tag="li"
                  >
                    <InsightSlot insight={insight} />
                  </Text>
                ))}
              </Text>
            </Column>
          )}
          {showErrorDetail && (
            <Text type="b100" color="secondary">{MISSING_VALUE}</Text>
          )}
        </Column>
      </Row>
    </Tile>
  );
};

export default InviteeCard;
